import { useParams } from "react-router-dom";
export function UserProfilePage() {
  const { username } = useParams();
  return <div><h1>{username}</h1><p className="muted">Profil public.</p></div>;
}
